import { PageForm } from "/src/layouts/page";
import AccountInformation from "/src/features/user/components/AccountInformation/AccountInformation"
import './AccountProfil.css';

function AccountProfil() {
    return (
        <PageForm className="user-section">
            <AccountInformation/>
        </PageForm >
    )
}

export default AccountProfil